import myAxios from "@/utils/request";
export default {
  // 政策通知管理
  getMessageList(params) {
    return myAxios.post("/api/policy/getpolicybyselect", params);
  },
  batchMessageDelete(params) {
    return myAxios.post("/api/policy/batchdelete", params);
  },
  addMessage(params) {
    return myAxios.post("/api/policy/addormodify", params);
  },
  getMessageInfo(params) {
    const { id } = params;
    return myAxios.get("/api/policy/getpolicybyid?id=" + id);
  },
  getMessageKeys() {
    return myAxios.get("/api/policy/getpolicykeywords");
  },
  getMessageAuditList(params) {
    return myAxios.post("/api/policy/getauditpolicybyselect", params);
  },

  // 政策解读管理
  getExplainList(params) {
    return myAxios.post(
      "/api/policydocumentation/getpolicydocumentationbyselect",
      params
    );
  },
  batchExplainDelete(params) {
    return myAxios.post("/api/policydocumentation/batchdelete", params);
  },
  addExplain(params) {
    return myAxios.post("/api/policydocumentation/addormodify", params);
  },
  getExplainInfo(params) {
    const { id } = params;
    return myAxios.get(
      "/api/policydocumentation/getpolicydocumentationbyid?id=" + id
    );
  },
  getExplainKeys() {
    return myAxios.get(
      "/api/policydocumentation/getpolicydocumentationkeywords"
    );
  },
  getExplainAuditList(params) {
    return myAxios.post(
      "/api/policydocumentation/getauditpolicydocumentationbyselect",
      params
    );
  },

  // 项目管理
  getProjectList(params) {
    return myAxios.post("/api/item/getitembyselect", params);
  },
  batchProjectDelete(params) {
    return myAxios.post("/api/item/batchdelete", params);
  },
  addProject(params) {
    return myAxios.post("/api/item/addormodify", params);
  },
  getProjectInfo(params) {
    const { id } = params;
    return myAxios.get("/api/item/getitembyid?id=" + id);
  },
  // 项目申报管理
  getDeclareList(params) {
    return myAxios.post("/api/declaration/getdeclarationmodelbyselect", params);
  },
  batchDeclareDelete(params) {
    return myAxios.post("/api/declaration/batchdelete", params);
  },
  // 项目公示管理
  getPublicityList(params) {
    return myAxios.post("/api/publicity/getpublicitybyselect", params);
  },
  batchPublicityDelete(params) {
    return myAxios.post("/api/publicity/batchdelete", params);
  },
  addPublicity(params) {
    return myAxios.post("/api/publicity/addormodify", params);
  },
  getPublicityInfo(params) {
    const { id } = params;
    return myAxios.get("/api/publicity/getpublicitybyid?id=" + id);
  }
};
